export default __webpack_public_path__ + "static/media/USDT.cec544c4.svg";